import styled from 'styled-components';

/* Centred in what is left of the dark screen below the logo, so the spinner sits
   roughly where step 0's card does rather than pinned to the top. */
export const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 72px 16px;
`;

export const LoadingContent = styled.p`
  text-align: center;
  margin: 0;
  /* Light ink: LoadingState's own colour is set for the light layout this screen
     used to render in. */
  color: rgba(255, 255, 255, 0.72);
`;
